import styled from 'styled-components/macro';

const $InputContainer = styled.div`
  flex: 1;
  position: relative;
`;

export default $InputContainer;
